/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '@swisslife/patterns-base/src/atoms/link/css/link';
import '@swisslife/patterns-base/src/atoms/text/css/text';
import '@swisslife/patterns-base/src/atoms/loader/css/loader';
import '@swisslife/patterns-base/src/molecules/list-filter/css/list-filter';
import '@swisslife/patterns-base/src/molecules/toast/css/toast';
import '../../../molecules/purpose-hub-teaser/css/purpose-hub-teaser';
import './purpose-hub.scss';
